import React, {useEffect, useRef, useState} from 'react';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '../../../common/Container';
import {Features, Hero, Highlights, Dashboard, NewFeatures, NewFeatures2, Industry} from './components';
import {useLocation} from "react-router-dom";
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Zoom from '@mui/material/Zoom';

const Home = () => {
    const theme = useTheme();
    const location = useLocation();
    const industryRef = useRef<HTMLDivElement>(null);
    const [showScrollTop, setShowScrollTop] = useState(false);

    const industry = ["page-agro", "page-mining", "page-engineering", "page-tourism", "page-coal-chemistry", "page-petrochemistry"];

    useEffect(() => {
        // Проверяем, содержит ли URL хэш #industry
        let urls = document.referrer?.split("/")
        console.log("Referrer URLs:", urls);
        console.log("Last URL part:", urls[urls?.length - 1]);
        console.log("Is in industry array:", industry.includes(urls[urls?.length - 1]));

        if (industry.includes(urls[urls?.length - 1])) {
            console.log("Condition matched, attempting to scroll");
            setTimeout(() => {
                console.log("industryRef exists:", !!industryRef.current);
                industryRef.current?.scrollIntoView();
            }, 500);
        }
    }, []);

    // Обработчик прокрутки для показа/скрытия кнопки
    useEffect(() => {
        const handleScroll = () => {
            // Показываем кнопку, когда пользователь прокрутил вниз более чем на 300px
            setShowScrollTop(window.scrollY > 300);
        };

        // Добавляем слушатель событий прокрутки
        window.addEventListener('scroll', handleScroll);

        // Вызываем обработчик сразу, чтобы определить начальное состояние
        handleScroll();

        // Убираем слушатель при размонтировании компонента
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Функция для прокрутки вверх страницы
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Плавная прокрутка
        });
    };

    return (
        <Box>
            <Box bgcolor={theme.palette.background.default} position={'relative'}>
                <Hero/>
            </Box>
            <Container>
                {/*<Highlights/>*/}
                <Industry ref={industryRef}/>
            </Container>
            <Container>
                <Features/>
            </Container>
            <Container>
                <NewFeatures/>
            </Container>
            <Container>
                <NewFeatures2/>
            </Container>
            <Container>
                <Dashboard/>
            </Container>

            {/* Кнопка прокрутки вверх */}
            <Zoom in={showScrollTop}>
                <Fab
                    color="primary"
                    size="small"
                    aria-label="scroll back to top"
                    onClick={scrollToTop}
                    sx={{
                        position: 'fixed',
                        bottom: 16,
                        right: 16,
                        zIndex: 1000,
                    }}
                >
                    <KeyboardArrowUpIcon />
                </Fab>
            </Zoom>
        </Box>
    );
};

export default Home;